import { Injectable, inject } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { BrandService } from '@services/brand/brand.service';
import { from } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class ThemeInitGuard implements CanActivate {
  private readonly brand = inject(BrandService);
  private readonly router = inject(Router);

  canActivate() { 
    return from(this.brand.loadThemeOrNavigateToError(6000, 100)).pipe(
      map(() => true),
      catchError(async () => {
        return this.router.parseUrl('/error');
      })
    );
  }
}